import hlsjs from "hls.js";

export function getHLSLevel(url) {
  return new Promise((resolve, reject) => {
    if (hlsjs.isSupported()) {
      var hls = new hlsjs();

      hls.on(hlsjs.Events.LEVEL_LOADED, function (_, data) {
        console.log("manifest parsed", url, data);
        hls.destroy();
        resolve(data);
      });

      hls.on(hlsjs.Events.ERROR, function (_, data) {
        console.log("error", url, data);
        hls.destroy();
        reject(data);
      });

      hls.loadSource(url);
    }
  });
}

export async function getFirstDurationOfAHlsFragment(url) {
  const m3u8FileManifest = await getHLSLevel(url);

  const fragments = m3u8FileManifest.details.fragments;
  const firstFragment = fragments[0];
  return firstFragment.duration;
}

export function isHlsVideo(url) {
  const videoUrlLower = url?.toLowerCase();
  return videoUrlLower?.endsWith(".m3u8") || videoUrlLower?.endsWith(".m3u");
}
